import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      phone: null, //电话
      heartbeat: false, //心动
      isPhone: false, //打电话
      id: '', //列表ID
      vipMessage: {},
      list: [
        { name: '心动', img: require('../../assets/image/new/heartbeat.png') },
        { name: '帮我约TA', img: require('../../assets/image/new/phone.png') },
      ],
      swiperOptiona: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 18,
        // loop : true,
        autoplay: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      isApprove: false, //实名认证
    }
  },
  created() {
    this.id = this.$route.query.id
    this.getVipMessage()
    this.getPhone()
  },
  methods: {
    //关闭
    closePhone() {
      this.isPhone = false
    },
    //是否打电话
    changeIsPhone() {
      this.isPhone = false
    },
    //打电话
    changPhone() {
      this.isPhone = true
    },
    //提交心动账号
    submitHeartbeat() {
      this.$axios
        .post('/api/users/heard', {
          heart_id: this.id,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.heartbeat = false
          }
        })
    },
    //选择哪个
    changeI(index) {
      if (!localStorage.getItem('incredible-k')) {
        this.$router.push('/login')
        return
      }
      if (index == 0) {
        this.heartbeat = !this.heartbeat
      } else {
        this.isPhone = !this.isPhone
      }
    },
    //收藏
    changeCollect(flag) {
      this.$axios
        .post('/api/users/goodsCollect', {
          collect_id: this.vipMessage.u_id,
          flag,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.vipMessage.is_collect == 0 ? (this.vipMessage.is_collect = 1) : (this.vipMessage.is_collect = 0)
            this.$message({
              message: res.data.msg,
              type: 'success',
            })
          } else {
            this.$message.error(res.data.msg)
          }
        })
    },
    //向左
    slidePrev() {
      this.$refs.mySwiper.$swiper.slidePrev()
    },
    //向右
    slideNext() {
      this.$refs.mySwiper.$swiper.slideNext()
    },
    //获取会员详情
    getVipMessage() {
      this.$axios
        .post('/api/index/luckDetail', {
          u_id: this.id,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.vipMessage = res.data.data
          }
        })
    },
    getPhone() {
      this.$axios.post('/api/index/contactUs').then((res) => {
        if (res.data.code === 0) {
          this.phone = res.data.data
        }
      })
    },
  },
}
